import type { Dispatch, UnknownAction } from '@reduxjs/toolkit'
import { useEffect, useRef } from 'react'

import { HEARTBEAT_INTERVAL_MS } from './actions'
import { sessionHeartbeatRequested } from './commands'
import type { MineVm } from './types'

/**
 * Пульс своей работы за кассой, пока окно РМК открыто. Только время связи:
 * кассу молчание не освобождает (C3a), поэтому скрытая вкладка пульс не шлёт.
 * Сессия и версия читаются из ref: смена версии не перезапускает таймер.
 */
export function useRmkHeartbeat(resourceId: string, mine: MineVm | null, dispatch: Dispatch<UnknownAction>): void {
  const current = useRef(mine)
  useEffect(() => {
    current.current = mine
  }, [mine])
  // Рабочее место в другой вкладке: пульс оттуда не наш, отсюда он только получил бы отказ (RP-CA5).
  const active = mine !== null && mine.thisTab

  useEffect(() => {
    if (!active) return undefined
    const timer = setInterval(() => {
      const session = current.current
      if (session === null || document.visibilityState !== 'visible') return
      dispatch(
        sessionHeartbeatRequested({
          resourceId,
          deviceId: session.deviceId,
          registerKey: session.registerKey,
          sessionId: session.sessionId,
          expectedVersion: session.version,
        }),
      )
    }, HEARTBEAT_INTERVAL_MS)
    return () => clearInterval(timer)
  }, [active, dispatch, resourceId])
}
